import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { postApiRequest } from "../../services/postApiRequest";
import { END_POINTS } from "../../Helper/Constant";
import { getApiRequest } from "../../services/getApiRequest";
import { hideLoader, showLoader } from "../loader/loaderSlice";

export const addToCart = createAsyncThunk(
  "cart/addToCart",
  async (payload, {dispatch, rejectWithValue }) => {
      dispatch(showLoader());
    try {
      const response = await postApiRequest(END_POINTS.ADD_TO_CART, payload);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to add product to cart"
      );
    }finally {
      dispatch(hideLoader());
    }
  }
);

export const fetchCart = createAsyncThunk(
  "cart/fetchCart",
  async (lang, {dispatch, rejectWithValue }) => {
  console.log('lang: ', lang);
    dispatch(showLoader());
    try {
      const response = await getApiRequest(`${END_POINTS.GET_ALL_CART_ITEMS}/?lang=${lang}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch cart");
    }finally {
      dispatch(hideLoader());
    }
  }
);

const cartSlice = createSlice({
  name: "cart",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearCart: (state) => {
      state.items = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // ➕ Add to Cart
      .addCase(addToCart.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      // eslint-disable-next-line no-unused-vars
      .addCase(addToCart.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(addToCart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // 🛒 Fetch Cart
      .addCase(fetchCart.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCart.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchCart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCart } = cartSlice.actions;
export default cartSlice.reducer;
